var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { stringToUint8Array } from "@hyper-hyper-space/hhs3_crypto";
import { json } from "@hyper-hyper-space/hhs3_json";
export * from "./dag_defs.js";
export * from "./dag_meet.js";
export * as store from "./store/index.js";
export * as idx from "./idx/index.js";
export function createHeader(payload, after, hash) {
    const payloadHash = hash.hashToB64(stringToUint8Array(json.toStringNormalized(payload)));
    const prevEntryHashes = json.toSet(after !== null && after !== void 0 ? after : new Set());
    const header = { payloadHash, prevEntryHashes };
    return header;
}
export function createEntry(payload, meta, after, hash) {
    const header = createHeader(payload, after, hash);
    const entryHash = hash.hashToB64(stringToUint8Array(json.toStringNormalized(header)));
    const entry = { hash: entryHash, header, payload, meta };
    return entry;
}
export function position(...hashes) {
    return new Set(hashes);
}
export function create(store, index, hash) {
    // Read-only view: avoids deferred-conditional-type errors when Tx is generic
    const ro = store;
    return {
        append: (payload, meta, after) => __awaiter(this, void 0, void 0, function* () {
            const e = createEntry(payload, meta, after, hash);
            yield store.withTransaction((...tx) => __awaiter(this, void 0, void 0, function* () {
                for (const prev of after || []) {
                    if ((yield store.loadHeader(prev, ...tx)) === undefined) {
                        throw new Error('cannot add ' + e.hash + ' before ' + prev);
                    }
                }
                yield index.index(e.hash, after, ...tx);
                yield store.append(e, ...tx);
                return { fireListeners: true };
            }));
            return e.hash;
        }),
        computeEntryHash: (payload, after) => __awaiter(this, void 0, void 0, function* () {
            const e = createEntry(payload, {}, after, hash);
            return e.hash;
        }),
        loadEntry: (h) => ro.loadEntry(h),
        loadHeader: (h) => ro.loadHeader(h),
        getFrontier: () => ro.getFrontier(),
        findMinimalCover: (p) => __awaiter(this, void 0, void 0, function* () { return index.findMinimalCover(p); }),
        findForkPosition: (first, second) => __awaiter(this, void 0, void 0, function* () { return index.findForkPosition(first, second); }),
        findCoverWithFilter: (from, filter, predicate) => __awaiter(this, void 0, void 0, function* () { return index.findCoverWithFilter(from, filter, predicate); }),
        findConcurrentCoverWithFilter: (from, concurrentTo, filter, predicate) => __awaiter(this, void 0, void 0, function* () { return index.findConcurrentCoverWithFilter(from, concurrentTo, filter, predicate); }),
        loadAllEntries: () => ro.loadAllEntries(),
        addListener: (cb) => ro.addListener(cb),
        removeListener: (cb) => ro.removeListener(cb),
        getStore: () => store,
        getIndex: () => index
    };
}
export function copy(from, to) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        try {
            for (var _d = true, _e = __asyncValues(from.loadAllEntries()), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true) {
                _c = _f.value;
                _d = false;
                const e = _c;
                yield to.append(e.payload, e.meta, new Set(json.fromSet(e.header.prevEntryHashes)));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
}
